import { markRaw } from 'vue'
import ModalAbstract from './ModalAbstract'
import ModalCarousel from './ModalCarousel.vue'

export default class ModalCarouselService extends ModalAbstract {
  public name = 'ModalCarouselService'
  protected component = markRaw(ModalCarousel)
}
